import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';
import { chipsMIN200k } from './chipsValues';

export const CHIPS_MIN_5k: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.BLUE,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 20e3,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 50e3,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 100e3,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 200e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 500e3,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 1e6,
  },
];

export const CHIPS_MIN_5k_v2: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.BLUE,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 50e3,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 100e3,
  },
  ...chipsMIN200k,
  {
    color: CHIPS_COLORS.PURPLE,
    value: 50e6,
  },
  {
    color: CHIPS_COLORS.LIGHT_GREEN,
    value: 100e6,
  },
];
